/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum PhoneType {
    PHONE_TYPE_LAND_LINE = 'PHONE_TYPE_LAND_LINE',
    PHONE_TYPE_MOBILE = 'PHONE_TYPE_MOBILE',
}

export enum Status {
    NORMAL = 'NORMAL',
    WARNING = 'WARNING',
    DANGER = 'DANGER',
    UNKNOWN = 'UNKNOWN',
}

export enum AxleSide {
    LEFT = 'LEFT',
    RIGHT = 'RIGHT',
}

export enum AxlePosition {
    FRONT_AXLE = 'FRONT_AXLE',
    REAR_AXLE_1 = 'REAR_AXLE_1',
    REAR_AXLE_2 = 'REAR_AXLE_2',
    REAR_AXLE_3 = 'REAR_AXLE_3',
    REAR_AXLE_4 = 'REAR_AXLE_4',
    REAR_AXLE_5 = 'REAR_AXLE_5',
    REAR_AXLE_6 = 'REAR_AXLE_6',
    REAR_AXLE_7 = 'REAR_AXLE_7',
    REAR_AXLE_8 = 'REAR_AXLE_8',
    REAR_AXLE_9 = 'REAR_AXLE_9',
    REAR_AXLE_10 = 'REAR_AXLE_10',
    REAR_AXLE_11 = 'REAR_AXLE_11',
    REAR_AXLE_12 = 'REAR_AXLE_12',
    RESERVE_WHEELS = 'RESERVE_WHEELS',
}

export enum BusinessType {
    SERVICE_PARTNER = 'SERVICE_PARTNER',
    IMPORTER = 'IMPORTER',
    WORKSHOP = 'WORKSHOP',
    NSC = 'NSC',
}

export interface BrakePageResponse {
    content?: Brake[];
    page?: PageMetadata;
}

export interface GroupedBrakePageResponse {
    content?: GroupedBrake[];
    page?: PageMetadata;
}

export interface PageMetadata {
    /** @format int32 */
    page_size?: number;
    /** @format int32 */
    page_number?: number;
    /** @format int64 */
    total_elements?: number;
    /** @format int32 */
    total_pages?: number;
}

export interface Brake {
    axle_position?: AxlePosition;
    axle_side?: AxleSide;
    /** @format float */
    value?: number;
    status?: Status;
    /** @format uuid */
    resource_id: string;
    account: Account;
    workshop?: Workshop;
    asset: Asset;
    measured_at?: MeasuredAt;
}

export interface Account {
    /** @format uuid */
    id: string;
    name: string;
}

export interface Workshop {
    id: string;
    name: string;
    workshop_address?: Address;
    business_type?: BusinessType;
    is_training?: boolean;
}

export interface Asset {
    /** @format uuid */
    id: string;
    name: string;
    vin: string;
}

export interface MeasuredAt {
    /** @format date-time */
    timestamp: string;
    /** @format float */
    mileage?: number;
}

/** Details of the vehicle assignment. */
export interface Assignment {
    /** @format uuid */
    asset_id: string;
    workshop_id: string;
    /** The user from the fleet account who is also the contact person for the vehicle. */
    contact_person: ContactPerson;
    /** Fleet account the vehicle is part of. */
    fleet_account: FleetAccount;
}

/** The user from the fleet account who is also the contact person for the vehicle. */
export interface ContactPerson {
    /** @format uuid */
    id: string;
    name: string;
    email?: string;
    phone_numbers: PhoneNumber[];
}

/** Fleet account the vehicle is part of. */
export interface FleetAccount {
    id: string;
    name?: string;
    address?: Address;
}

export interface Address {
    street?: string;
    city?: string;
    zip?: string;
    /** @example "DE" */
    country_code?: string;
}

/** @example {"number":"+49 30 123456789","type":"PHONE_TYPE_LAND_LINE"} */
export interface PhoneNumber {
    /** @example "+49 30 123456789" */
    number: string;
    type: PhoneType;
}

export interface BrakeLiningSettings {
    columns: BrakeLiningColumns;
    filters: BrakeLiningFilters;
    sort: Sorting;
}

export interface BrakeLiningColumns {
    /** @example true */
    vehicle: boolean;
    /** @example false */
    vin: boolean;
    /** @example true */
    customer: boolean;
    /** @example false */
    workshop?: boolean | null;
}

export interface BrakeLiningFilters {
    /** @example 10 */
    min?: number | null;
    /** @example 50 */
    max?: number | null;
    /** @example ["DANGER","WARNING"] */
    status?: Status[] | null;
}

export interface Sorting {
    /** @example "vehicle" */
    sort_by?: string | null;
    /** @example "ASC" */
    sort_direction?: 'ASC' | 'DESC' | null;
}

export interface GroupedBrake {
    axle_position?: AxlePosition;
    left?: BrakeSideData;
    right?: BrakeSideData;
    account: Account;
    workshop: Workshop;
    asset: Asset;
}

export interface BrakeSideData {
    /** @format float */
    value: number;
    status: Status;
    /** @format uuid */
    resource_id: string;
    /** @format date-time */
    timestamp?: string;
    /** @format float */
    mileage?: number;
}

export declare namespace Brakes {
    /**
     * @description Retrieves paginated brakes data for assigned assets
     * @tags Brakes
     * @name GetBrakes
     * @summary Get brakes data
     * @request GET:/brakes
     * @secure
     * @response `200` `BrakePageResponse` Success
     * @response `400` `any`
     * @response `403` `any`
     * @response `404` `void` No brakes data found
     * @response `default` `any`
     */
    export namespace GetBrakes {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Number of items per page
             * @min 1
             * @max 100
             * @default 20
             * @example 23
             */
            page_size?: number;
            /**
             * Page number (zero-based)
             * @min 0
             * @default 0
             * @example 1
             */
            page_number?: number;
            /**
             * @default "vehicle"
             * @example "axlePosition"
             */
            sort_by?: 'vehicle' | 'vin' | 'customer' | 'workshop' | 'axlePosition' | 'left' | 'right';
            /** @default "ASC" */
            sort_direction?: 'ASC' | 'DESC';
            /**
             * Used to filter the response to contain only brakes for the specified assets
             * @example "47ec272b-d9eb-4ec1-9fe6-e0bc5ae23b80,f41f3f7e-e4f4-47c2-8067-4e2dbeb7668a,be3e639b-465f-49b8-b710-c254c6fbd3e8"
             */
            asset_ids?: string[];
            account_ids?: string[];
            workshop_ids?: string[];
            /**
             * Used to filter the response to contain only brakes with pressure values at least at min
             * @min 0
             * @max 100
             * @default 0
             * @example 15
             */
            min?: number;
            /**
             * Used to filter the response to contain only brakes with pressure values at most at max
             * @min 0
             * @max 100
             * @default 100
             * @example 85
             */
            max?: number;
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = BrakePageResponse;
    }

    /**
     * @description Retrieves paginated grouped brakes data (left/right pairs) for assigned assets
     * @tags Brakes
     * @name GetGroupedBrakes
     * @summary Get grouped brakes data
     * @request GET:/brakes/grouped
     * @secure
     * @response `200` `GroupedBrakePageResponse` Success
     * @response `400` `any`
     * @response `403` `any`
     * @response `404` `void` No brakes data found
     * @response `default` `any`
     */
    export namespace GetGroupedBrakes {
        export type RequestParams = {};
        export type RequestQuery = {
            /**
             * Number of items per page
             * @min 1
             * @max 100
             * @default 20
             * @example 23
             */
            page_size?: number;
            /**
             * Page number (zero-based)
             * @min 0
             * @default 0
             * @example 1
             */
            page_number?: number;
            /**
             * @default "vehicle"
             * @example "axlePosition"
             */
            sort_by?: 'vehicle' | 'vin' | 'customer' | 'workshop' | 'axlePosition' | 'left' | 'right';
            /** @default "ASC" */
            sort_direction?: 'ASC' | 'DESC';
            /**
             * Used to filter the response to contain only brakes for the specified assets
             * @example "47ec272b-d9eb-4ec1-9fe6-e0bc5ae23b80,f41f3f7e-e4f4-47c2-8067-4e2dbeb7668a"
             */
            asset_ids?: string[];
            /**
             * Used to filter the response to contain only brakes with pressure values at least at min
             * @min 0
             * @max 100
             * @default 0
             * @example 15
             */
            min?: number;
            /**
             * Used to filter the response to contain only brakes with pressure values at most at max
             * @min 0
             * @max 100
             * @default 100
             * @example 85
             */
            max?: number;
            /**
             * Used to filter the response to contain only brakes with the specified status
             * @example "DANGER"
             */
            status?: ('DANGER' | 'WARNING' | 'NORMAL')[];
        };
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = GroupedBrakePageResponse;
    }
}

export declare namespace Assets {
    /**
     * @description Retrieves brakes data for a specific asset
     * @tags Brakes
     * @name GetBrakesForAsset
     * @summary Get brakes data for specific asset
     * @request GET:/assets/{assetId}/brakes
     * @secure
     * @response `200` `(Brake)[]` Success
     * @response `400` `any`
     * @response `403` `any`
     * @response `default` `any`
     */
    export namespace GetBrakesForAsset {
        export type RequestParams = {
            /**
             * assetId of the vehicle
             * @format uuid
             */
            assetId: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {
            /** Token received in case of vin-search */
            'X-Auth'?: string;
        };
        export type ResponseBody = Brake[];
    }
}

export declare namespace Workshops {
    /**
     * @description Retrieves workshop information by workshop ID.
     * @tags Workshops
     * @name GetWorkshop
     * @request GET:/workshops/{id}
     * @secure
     * @response `200` `Workshop` Success
     * @response `400` `any`
     * @response `403` `any`
     * @response `404` `void` Workshop not found
     * @response `default` `any`
     */
    export namespace GetWorkshop {
        export type RequestParams = {
            /** ID of the workshop. */
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = Workshop;
    }
}

export declare namespace Assignments {
    /**
     * @description Retrieves assignment information for a specific asset.
     * @tags Assignments
     * @name GetAssignmentForAsset
     * @request GET:/assignments/{id}
     * @secure
     * @response `200` `Assignment` Success
     * @response `400` `any`
     * @response `403` `any`
     * @response `404` `void` Assignment not found
     * @response `default` `any`
     */
    export namespace GetAssignmentForAsset {
        export type RequestParams = {
            /**
             * The Id of the asset of the vehicle.
             * @format uuid
             */
            id: string;
        };
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = Assignment;
    }
}

export declare namespace Export {
    /**
     * @description Exports grouped brakes data as CSV file with localized headers
     * @tags Export
     * @name ExportBrakes
     * @summary Export brakes data as CSV
     * @request GET:/export/brakes
     * @secure
     * @response `200` `File` CSV file with brakes data
     * @response `default` `any`
     */
    export namespace ExportBrakes {
        export type RequestParams = {};
        export type RequestQuery = {
            /** @default 20 */
            page_size?: number;
            /** @default 0 */
            page_number?: number;
            /** @default "vehicle" */
            sort_by?: 'vehicle' | 'vin' | 'customer' | 'workshop' | 'axlePosition' | 'left' | 'right';
            /** @default "ASC" */
            sort_direction?: 'ASC' | 'DESC';
            asset_ids?: string[];
            account_ids?: string[];
            workshop_ids?: string[];
            /**
             * @min 0
             * @max 100
             * @default 0
             */
            min?: number;
            /**
             * @min 0
             * @max 100
             * @default 100
             */
            max?: number;
            /**
             * Used to filter the response to contain only brakes with the specified status
             * @example "DANGER"
             */
            status?: ('DANGER' | 'WARNING' | 'NORMAL')[];
        };
        export type RequestBody = never;
        export type RequestHeaders = {
            /**
             * Language code for CSV headers (e.g., en-GB, de-DE)
             * @default "en-GB"
             */
            'Accept-Language'?: string;
        };
        export type ResponseBody = File;
    }
}

export declare namespace UserSettings {
    /**
     * @description Retrieves user preferences for brake lining table (columns, filters, sorting). Returns defaults if not found.
     * @tags User Settings
     * @name GetBrakeLiningSettings
     * @summary Get brake lining table settings
     * @request GET:/user-settings/brake-lining
     * @secure
     * @response `200` `BrakeLiningSettings` Brake lining settings
     * @response `401` `any`
     * @response `default` `any`
     */
    export namespace GetBrakeLiningSettings {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = never;
        export type RequestHeaders = {};
        export type ResponseBody = BrakeLiningSettings;
    }

    /**
     * @description Creates or updates user preferences for brake lining table
     * @tags User Settings
     * @name UpdateBrakeLiningSettings
     * @summary Update brake lining table settings
     * @request PUT:/user-settings/brake-lining
     * @secure
     * @response `200` `BrakeLiningSettings` Updated settings
     * @response `400` `any` Validation error (e.g., min > max, invalid sort direction)
     * @response `401` `any`
     * @response `default` `any`
     */
    export namespace UpdateBrakeLiningSettings {
        export type RequestParams = {};
        export type RequestQuery = {};
        export type RequestBody = BrakeLiningSettings;
        export type RequestHeaders = {};
        export type ResponseBody = BrakeLiningSettings;
    }
}
